<ng-container *transloco="let t">
  <h1 mat-dialog-title>{{ t('support.create') }}</h1>
  <div mat-dialog-content>
    @if (data?.reason) {
      <div class="flex align-center gap-xs radius-4px bg-table-warn space-xs-top space-xs-bottom space-xs-left space-xs-right margin-xs-bottom">
        <mat-icon class="material-symbols-outlined" style="flex-shrink: 0">info</mat-icon>
        <span>{{ data.reason }}</span>
      </div>
    }
    <div [formGroup]="supportData">
      @if (provideEmail) {
        <mat-form-field>
          <mat-label>{{ t('support.email') }} </mat-label>
          <input matInput formControlName="email" />
          @if (supportData.get('email').invalid) {
            <mat-error>{{ t('support.error_email') }}</mat-error>
          }
        </mat-form-field>
      }
      <p>
        <small>
          {{ t('support.problem.description.hint') }}
          <br />
          {{ t('support.problem.description.hint2') }}
        </small>
      </p>
      <mat-form-field>
        <mat-label>{{ t('support.problem.title') }} </mat-label>
        <input matInput formControlName="subject" />
        @if (supportData.get('subject').invalid) {
          <mat-error>{{ t('support.error_subject') }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label style="white-space: normal; word-wrap: break-word; line-height: 1.2">{{ t('support.problem.description') }} </mat-label>
        <textarea formControlName="body" matInput rows="5"></textarea>
        @if (supportData.get('body').invalid) {
          <mat-error>{{ t('support.error_body') }}</mat-error>
        }
      </mat-form-field>
      
      @if (!provideEmail) {
      <div class="space-xs-top">
        <p><small>{{ t('support.attachment.hint') }}</small></p>
        <input #fileInput type="file" multiple class="file-list__input" (click)="resetFileInput()" (change)="handleFileInput($event.target.files)" accept="image/*,.pdf,.doc,.docx,.txt" />
        <button mat-stroked-button (click)="fileInput.click()" type="button" [disabled]="selectedFiles.length >= maxFiles">
          <mat-icon>attach_file</mat-icon>
          {{ t('support.attachment.choose') }}
        </button>
        @if (selectedFiles.length > 0) {
          <div class="file-list space-xs-top">
            @for (file of selectedFiles; track file.name + $index) {
              <div class="file-list__item">
                <div class="file-list__icon">
                  @if (file.type.startsWith('image/')) {
                    <mat-icon>image</mat-icon>
                  } @else {
                    <mat-icon>description</mat-icon>
                  }
                </div>
                <div class="file-list__info">
                  <span class="file-list__name">{{ file.name }}</span>
                </div>
                <button mat-icon-button type="button" class="file-list__remove" (click)="removeFile($index)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    }
    </div>
  </div>
  <div mat-dialog-actions>
    <span class="flex-grow-1"></span>
    <button mat-button type="button" (click)="onCloseClicked()">{{ t('general.close') }}</button>
    <button mat-button (click)="onCreateClicked()" [disabled]="isSending || supportData.invalid">
      {{ isSending ? t('general.please_wait') : t('general.send') }}
      @if (isSending) {
        <mat-progress-bar mode="indeterminate" />
      }
    </button>
  </div>
</ng-container>
